
import Spinner from "@/components/Spinner/Spinner";
import { Button } from "@/components/UiElements";
import updateTheme from "@/services/ThemeService/updateTheme";
import addTheme from "@/services/ThemeService/addTheme";
import { Theme } from "@/types/theme";
import { ChangeEvent, useState } from "react";
import { toast } from "react-toastify";
import notifyError from "@/utils/notifyError";

type PricingFormProps = {
  oldTheme?: Theme
  onUpdateSuccess?: (updatedTheme: Theme) => void
  closeModal?:  () => void
}

const ThemeForm = ({
                     oldTheme,
                       onUpdateSuccess,
                       closeModal
                     }: PricingFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(oldTheme?.title || '');

  const handleCreateTheme = async () => {
    if (name ==='') {
      notifyError(`Name cannot be empty.`);
      return;
    }
    setIsLoading(true)
    await addTheme(
        {title:name,theme:null}
    );
    toast.success('Theme added successfully')
    setIsLoading(false)
    closeModal && closeModal()
  }

  const handleEditTheme = async () => {
    if (!oldTheme?.id) {
      return;
    }
    if (name ==='') {
      notifyError(`Name cannot be empty.`);
      return;
    }

    setIsLoading(true)

    const theme: Theme = {
      id: oldTheme?.id,
      title: name,
      theme: oldTheme.theme,
      created_at: oldTheme.created_at,
      changed_at: oldTheme.changed_at,
    }
    await updateTheme(theme);
    onUpdateSuccess && onUpdateSuccess(theme)
    toast.success('Theme updated successfully')
    setIsLoading(false)
    closeModal && closeModal()
  }

  return (
      <div className={'flex flex-col justify-center p-5'}>
        <h2 className="text-lg font-extrabold my-3">{oldTheme ? 'Rename Theme' : 'Add theme'}</h2>
        <div className="flex justify-start">
          <div className='w-full my-3'>
            <input
                type='text'
                name='name'
                id='name'
                placeholder=''
                value={name}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                className='transition-all outline-none
              w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
              placeholder:text-gray-400 placeholder:text-text-md
              focus:shadow-focus focus:border-primary-500
              hover:border-primary-500 shadow-xs
              h-[44px] px-md'
            />
          </div>
        </div>
        <Button disabled={isLoading} onClick={oldTheme ? handleEditTheme : handleCreateTheme}>{isLoading ? <Spinner /> : (oldTheme ? 'Update theme' : 'Add theme')}</Button>
      </div>
  )
}

export default ThemeForm
